import React from 'react';
import { styled } from 'linaria/react';
import { useQuery } from 'react-apollo';
import brandCategoryQuery from './BrandCategoryQuery.gql';
import recommendedProductsQuery from './RecommendedProductsQuery.gql';
import { StyledProductRow } from '../../../ContentEditor/ProductRow';
import { ProductRowItem } from '../../../ContentEditor/ProductRowItem';

const Wrapper = styled('div')`
  margin-bottom: 20px;
`;

const useBrandCategoryId = brand => {
  const { data, loading, error } = useQuery(brandCategoryQuery, {
    variables: { id: 177 }
  });
  if (loading || error) {
    return null;
  }
  const match = data?.category?.subcategories?.find(subcat =>
    subcat?.name?.toLowerCase().startsWith(brand.toLowerCase())
  );
  return match?.id;
};

const BrandProducts = ({ brand }) => {
  const brandCategoryId = useBrandCategoryId(brand);
  const { data, error } = useQuery(recommendedProductsQuery, {
    variables: {
      id: brandCategoryId
    }
  });
  if (!data || error) {
    return null;
  }
  return (
    <Wrapper>
      <StyledProductRow
        fullWidth={{ value: true }}
        gap={{ value: 20 }}
        padding={{ value: false }}
        cartPage={{ value: false }}
        title={{ value: 'Populära produkter från ' + data?.category?.name }}
        link={{ value: data?.category?.primaryRoute?.path }}
        buttonText={{ value: 'Se mer från ' + data?.category?.name }}
        backgroundColor={{ value: '#F8F7F5' }}
        textColor={{ value: '#333333' }}
      >
        {data?.category?.products?.result.map(prod => (
          <ProductRowItem key={prod.id} product={prod} />
        ))}
      </StyledProductRow>
    </Wrapper>
  );
};
export default BrandProducts;
